module.exports = __webpack_public_path__ + "static/media/soldiers.92d08bd3544bc82f53813f67d3bb6abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/features/soldiers.png
// module id = 1109
// module chunks = 1